import apps from "../apps";

const { TEMBO_CLIENT } = apps;

export function isHavePermissionThisApp(user) {
    try {
        if (user.profile.IsSuperAdmin) return true;
        const apps = user.profile.Apps.split(',');
        console.error("apps", apps, TEMBO_CLIENT.id, apps)
        if (apps.indexOf(TEMBO_CLIENT.id) > -1) {
            return true;
        }
    } catch(e) {
        console.error(e)
        return false;
    }
    return false
}

export function getTheAppsUrlToByRedirected(user) {
    try {
        const userApps = user.profile.Apps.split(',');
        try {
            Object.keys(apps).forEach((appName) => {
                console.log(userApps.indexOf(apps[appName].id))
                if (userApps.indexOf(apps[appName].id) > -1) {
                    console.error(apps[appName].url)
                    throw apps[appName].url;
                }
            })
        } catch (url) {
            return url;
        }
    } catch (e) {
        return ""
    }
    
    return "";
}